//Generated by AI, Needs to be reviewed
import { FC } from 'react';
import styles from './RadioGroup.module.css';

export interface RadioOption {
  value: string;
  label: string;
  icon?: string;
}

interface RadioGroupProps {
  options: RadioOption[];
  value: string | boolean | undefined;
  onChange: (value: string) => void;
  name: string;
  direction?: 'vertical' | 'horizontal';
}

const RadioGroup: FC<RadioGroupProps> = ({ options, value, onChange, name, direction = 'vertical' }) => {
  return (
    <div className={`flex gap-6 w-full ${direction === 'horizontal' ? 'flex-row' : 'flex-col'}`}>
      {options.map((option) => {
        const isSelected = value === option.value || (typeof value === 'boolean' && value.toString() === option.value);
        return (
          <label
            key={option.value}
            className={`${styles.radioLabel} ${isSelected ? styles.selected : styles.unselected} ${direction === 'horizontal' ? 'flex-1' : ''}`}
          >
            {/* Icon on the LEFT in RTL */}
            {option.icon && (
              <div className={styles.icon}>
                <img src={option.icon} alt="" />
              </div>
            )}
            
            {/* Text in the MIDDLE */}
            <span className={`body-lr-semibold text-(--font-body-1) ${styles.labelText} ${isSelected ? styles.selected : styles.unselected}`}>
              {option.label}
            </span>
            
            {/* Radio button on the RIGHT in RTL */}
            <div className="flex items-center justify-center shrink-0 relative">
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={isSelected}
                onChange={(e) => onChange(e.target.value)}
                className={styles.radioInput}
              />
              <span className={styles.radioButton}></span>
            </div>
          </label>
        );
      })}
    </div>
  );
};

export default RadioGroup;

